import { mlflowApiClient } from '@/shared/api/core/axios-instance';

import type { ModelVersionSearchParams, ModelVersionSearchResponse } from '@/entities/model-version/domain';

export const fetchModelVersions = async (params: ModelVersionSearchParams): Promise<ModelVersionSearchResponse> => {
  const { data } = await mlflowApiClient.get<ModelVersionSearchResponse>('/ajax-api/2.0/mlflow/model-versions/search', {
    params,
  });
  return data;
};
